import Layout from "@/components/Layout";
import { XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <Layout>
      <div className="mx-auto max-w-2xl px-4 py-24 text-center">
        <XCircle className="w-16 h-16 text-amber-500 mx-auto" />
        <h1 className="hero-title text-4xl text-white mt-6">Deposit not completed.</h1>
        <p className="text-slate-400 mt-4">You can retry anytime. No charge was made.</p>
        <button data-testid="cancel-retry" onClick={() => nav("/onsite")} className="mt-8 btn-red px-8 py-4 rounded-sm">Try Again</button>
      </div>
    </Layout>
  );
}
